if (!customElements.get('akr-product-row')) {
  customElements.define(
    'akr-product-row',
    class AkrProductRow extends HTMLElement {
      connectedCallback() {
        this.list = this.querySelector('.akr-row__list');
        this.prevButton = this.querySelector('.akr-row__arrow--prev');
        this.nextButton = this.querySelector('.akr-row__arrow--next');
        if (!this.list) return;

        this.abortController = new AbortController();
        const { signal } = this.abortController;

        [this.prevButton, this.nextButton].forEach((button) => {
          button?.addEventListener('click', () => this.scrollByCard(Number(button.dataset.direction)), { signal });
        });
        this.list.addEventListener('scroll', () => this.update(), { signal, passive: true });
        window.addEventListener('resize', () => this.update(), { signal });
        this.update();
      }

      disconnectedCallback() {
        this.abortController?.abort();
      }

      scrollByCard(direction) {
        const item = this.list.querySelector('.akr-row__item');
        if (!item) return;

        const gap = parseFloat(getComputedStyle(this.list).columnGap) || 0;
        this.list.scrollBy({ left: direction * (item.getBoundingClientRect().width + gap) });
      }

      update() {
        const max = this.list.scrollWidth - this.list.clientWidth;
        this.classList.toggle('is-static', max <= 1);
        if (this.prevButton) this.prevButton.disabled = this.list.scrollLeft <= 1;
        if (this.nextButton) this.nextButton.disabled = this.list.scrollLeft >= max - 1;
      }
    }
  );
}
